import axiosInstance from "../Utils/axiosInstance";
import { CititesApi } from "../Constants/api";

export const getCitiesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${CititesApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
